import React from 'react'
import { strings } from '../../../localization/strings'
// import {IconButton} from "@material-ui/core";
// import Tooltip from "@material-ui/core/Tooltip/Tooltip";
import Copy from './copy.js'
import ConfigPanel from './configPanel'
// import RefreshIcon from '@material-ui/icons/Autorenew';
// import routes from '../../router/routes'
// import { getNewClientSecret } from '../../../helpers/restHelpers'
import { Button, makeStyles } from '@material-ui/core/index'
import routes from '../../router/routes'

const useStyles = makeStyles({
    documentationBtn: {
        fontSize: '14px',
        width: 'auto'
    },
})

const Component = ({ config, handleEdit }) => {
    const classes = useStyles()

    // const changeClientSecret = () => {
    //     handleEdit({ loader: true })
    //     getNewClientSecret()
    //         .then((x) =>
    //             handleEdit({
    //                 loader: false,
    //                 wasEdited: true,
    //                 config: { ...config, apiCredentialsClientSecret: x },
    //             })
    //         )
    //         .catch((x) =>
    //             window.showDialog(x, () =>
    //                 this.props.history.push(routes.orders.path)
    //             )
    //         )
    // }

    if (!config.apiCredentialsClientId || !config.apiCredentialsClientSecret)
        return null

    return (
        <ConfigPanel
            title={<div>
                {strings.apiCredentialsTitle} -
                <Button
                    className={classes.documentationBtn}
                    label={strings.seeEcommerceDocumentation}
                    color="primary"
                    fullWidth
                    onClick={() =>
                        window.open(window.location.href.split('/').slice(0, -1).join('/') + routes.ecommerceDocumentation.path)
                    }
                >
                    {strings.seeEcommerceDocumentation}
                </Button>
            </div>
            }
            items={[
                {
                    label: strings.apiCredentialsClientId,
                    control: (
                        <>
                            <div style={{ fontSize: '80%' }}>
                                {config.apiCredentialsClientId.toUpperCase()}
                            </div>
                            <Copy
                                color="inherit"
                                text={config.apiCredentialsClientId.toUpperCase()}
                            />
                        </>
                    ),
                },
                {
                    label: (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            {strings.apiCredentialsClientSecret}
                        </div>
                    ),
                    control: (
                        <>
                            <div style={{ fontSize: '66%' }}>
                                {config.apiCredentialsClientSecret}
                            </div>
                            <Copy
                                color="inherit"
                                text={config.apiCredentialsClientSecret}
                            />
                        </>
                    ),
                },
                {
                    label: (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            {strings.apiCredentialsClientIdSandbox}
                        </div>
                    ),
                    control: (
                        <>
                            <div style={{ fontSize: '80%' }}>
                                {config.apiCredentialsClientIdSandbox.toUpperCase()}
                            </div>
                            <Copy
                                color="inherit"
                                text={config.apiCredentialsClientIdSandbox.toUpperCase()}
                            />
                        </>
                    ),
                },
                {
                    label: (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            {strings.apiCredentialsClientSecretSandbox}
                        </div>
                    ),
                    control: (
                        <>
                            <div style={{ fontSize: '66%' }}>
                                {config.apiCredentialsClientSecretSandbox}
                            </div>
                            <Copy
                                color="inherit"
                                text={config.apiCredentialsClientSecretSandbox}
                            />
                        </>
                    ),
                },
            ]}
        />
    )
}

export default Component
